import React, { useState } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import circle from "../../../../assets/DigitalMarketing/image/dashboard/circle_down.svg";
import Tabs from "../../../../Component/DigitalMarketing/Tabs";

function ChartBox(props) {
  const [active, setActive] = useState(1);
  const { element, title, tablist, element1 } = props;
  return (
    <div className="cards h-100">
      <div className="d-flex justify-content-between">
        <h3 className="f-10 fw-300">{title}</h3>
        {/* <span>
          This week <img src={circle} alt="i" />
        </span> */}
        {/* <BsThreeDotsVertical className="c-blue cursur"/> */}
      </div>
      <Tabs tablist={tablist} active={active} setActive={setActive} />
      <div>{active === 1 ? element : element1}</div>
    </div>
  );
}

export default ChartBox;
